module.exports = __webpack_public_path__ + "img/icon-games-white.0ec85010.svg";